import { getSubscriptionPlan } from './subscriptionPlans'

/** App entry pricing comes from the product's own plan data. */
const starter = getSubscriptionPlan('starter')

export const appModel = {
  name: 'VEXU App',
  audience: 'Individuals & professionals',
  model: ['Subscription', 'Usage'],
  journey: ['Subscribe', 'Use', 'More usage'],
  price: `$${starter.price.toFixed(2)}`,
  revenueLabel: 'Consumer / prosumer recurring revenue',
}

export const businessModel = {
  name: 'VEXU Business',
  audience: 'Businesses',
  model: ['Platform', 'Usage', 'Expansion'],
  /** $1,188 annualized Starter business pricing — the Slide 9 basis. */
  price: '$99.00',
  revenueLabel: 'Business recurring revenue',
  expansion: [
    { stage: 'Land', detail: 'Voice' },
    { stage: 'Expand', detail: 'WhatsApp · Website AI' },
    { stage: 'Automate', detail: 'Workflows · Integrations' },
    { stage: 'Grow', detail: 'More usage' },
  ],
}

export const revenueExpansion = [
  'More customers',
  'More usage',
  'More capabilities',
  'More recurring revenue',
]

export const engineCapabilities = 'Voice · Intelligence · Memory · Actions'
